import styled from "styled-components";

export const Divider = styled.div`
    float: ${props => (props.float ? props.float : "none")};
    width: ${props => (props.width ? props.width : "auto")};
    padding: ${props => (props.padding ? props.padding : "0")};
    margin: ${props => (props.margin ? props.margin : "0")};
`;
